import React, { useCallback, useEffect, useState } from 'react';
import { Tappable } from '@vectord/components';
import { useSelector } from 'react-redux';
import cogoToast from 'cogo-toast';

import { useUpdateLessonMutation } from '@classCreation/services/lessonService';
import { classTagSelector } from '@classCreation/selectors/createClassForm';
import ClassTagField from '../ClassTagField';
import FieldErrors from 'components/FieldErrors';
import Form from 'components/Form';
import LessonInput from '../LessonInput';

export default function EditLessonForm({
  isEditing,
  setIsEditing,
  academyTopicId,
  value,
  label,
  classTagActions,
  classTagValue,
}) {
  const classTagState = useSelector(classTagSelector);

  const [lesson, setLesson] = useState(value);
  const [updateLesson, { isSuccess, error, isLoading: isUpdating, reset }] =
    useUpdateLessonMutation();

  useEffect(() => {
    if (!isEditing) {
      setLesson(value);
      if (error) {
        reset();
      }
    }
  }, [error, isEditing, reset, value]);

  const handleOnChange = useCallback((newLesson) => {
    setLesson(newLesson);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Lesson is successfully updated!');
      setIsEditing(false);
    }
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in updating the lesson. Please try again later!'
      );
    }
  }, [error, isSuccess, setIsEditing]);

  const handleEditLesson = useCallback(
    (event) => {
      event.preventDefault();
      updateLesson({ academyTopicId, lesson, classTag: classTagState });
    },
    [academyTopicId, classTagState, lesson, updateLesson]
  );

  return (
    <Form onSubmit={handleEditLesson}>
      <LessonInput
        lessonType={value.lesson_type}
        value={lesson}
        onChange={handleOnChange}
        disabled={!isEditing}
        className="m-b-xs"
      />
      {classTagValue && value.lesson_type === 'live_lecture' && (
        <ClassTagField
          classTag={classTagValue}
          actions={classTagActions}
          isEditing={isEditing}
        />
      )}
      <FieldErrors
        name="duration"
        errors={error?.data?.errors}
      />
      <FieldErrors
        name="test_id"
        errors={error?.data?.errors}
      />
      {isEditing && (
        <Tappable
          className="btn btn-primary"
          disabled={isUpdating}
          component="button"
          type="submit"
        >
          Update {label}
        </Tappable>
      )}
    </Form>
  );
}
